export default __webpack_public_path__ + "static/KeywordResearch_01_04-832a0010d86156c3eae0f838cd2d8345.png";